//import moment from 'moment';
import {RepositoryFactory} from '../api/RepositoryFactory'
const SettingsRepoGet = RepositoryFactory.get('settings')
const DiaryRepoGet = RepositoryFactory.get('diary')
const DiaryRepoPost = RepositoryFactory.post('diary')

export const mixin = {
	methods: {
		async getStoreSettings(storeId)
		{
			const {data}  =	await SettingsRepoGet.getAllStoreSettings(storeId)	
			console.log(data)	
			console.log(this.$store.state)	
			console.log(this.$store.state.loggedIn)
			this.$store.commit("getStoreSettings", data);
		},
		async getOrder(orderRef, pin, lastFour, notifyTel, notifyEmail, identifyType, storeId)
		{
			
			const {data} = await DiaryRepoGet.getOrder(orderRef, pin, lastFour, notifyTel, notifyEmail, identifyType, storeId)
			console.log(data[0])
			if(data != "invalid lastFour")
			{
				//let currentHour = moment().get('hour');
				//// Convert the data[0].slot_time text value to a numercial value that we can use to check against the sameDayOffset
				var slotHour = data[0].slot_time.substr(0, data[0].slot_time.indexOf(':'));  // get the first/second digit from the time string
				let slotPeriod = data[0].slot_time.slice(-2); // value will be  am or pm
				if (slotPeriod == "pm" && slotHour != 12) // add 12 hours to convert to 24 hour clock if pm 
				{
					slotHour = parseInt(slotHour) +  12;
				}
				this.authenticated = true
				if(data[0]["inFuture"] == "wrong date" || data[0]["inFuture"] == "too early")
				{
					this.toEarly = true
				}
				else
				{
					this.toEarly = false

				}		
					this.orderDetails.customerName = data[0].strSalutation
					this.orderDetails.collectionTime =  parseInt(slotHour) + ":00 "  + " to " + (parseInt(slotHour) + 1) + ":00 "
					this.orderDetails.collectionDate = data[0].slot_date
					this.orderDetails.orderId = data[0].strOrderId // this is the stores order id				
				//this.toEarly = (slotHour  >= currentHour + 1  || moment(moment().format("YYYY-MM-DD")).isBefore(data[0].slot_date) )? true : false
				
			}
			else
			{
				this.authenticated = false
			}
		//	console.log(data)
		},
		async updateIdentify(orderRef, identifyType, identify1, identify2, identify3, storeId , strOrderType, notificationTel, strOrderId, strSalutation, notificationEmail)
		{
			let payload = new FormData()
			payload.append('orderRef', orderRef)
			payload.append('identifyType', identifyType)
			payload.append('identify1', identify1)
			payload.append('identify2', identify2)
			payload.append('identify3', identify3)
			payload.append('notificationEmail', notificationEmail)
			payload.append('notificationTel', notificationTel)
			payload.append('strSalutation', strSalutation)
			payload.append('strOrderId', strOrderId)
			payload.append('strOrderType', strOrderType)
			payload.append('storeId', storeId)
			
			await DiaryRepoPost.postUpdateIdentify(payload)
		}
	},
	filters : {

	}
}